import { TOGGLE_MOBILE_MENU, TOGGLE_CHAT, SET_IS_WEBVIEW } from '../constants/actionTypes';

export function toggleMobileMenu() {
  return {
    type: TOGGLE_MOBILE_MENU
  };
}

export function toggleChat() {
  return {
    type: TOGGLE_CHAT
  };
}

export function setWebView() {
  return {
    type: SET_IS_WEBVIEW
  };
}
